import { useMainParticipant, useVideoContext, useScreenShareParticipant } from '@uplift/hooks';
import { ScrollableView } from '../Layout';
import { MainParticipantInfo } from './main-participant-info';
import { ParticipantTracks } from './participant-tracks';

export function MainParticipant() {
  const mainParticipant = useMainParticipant();
  const { room } = useVideoContext();
  const localParticipant = room?.localParticipant;
  const screenShareParticipant = useScreenShareParticipant();

  if (!localParticipant) {
    return null;
  }

  const videoPriority = (
    mainParticipant === screenShareParticipant
    && mainParticipant !== localParticipant
  )
    ? 'high'
    : null;

  return (
    /* audio is disabled for this participant component because this participant's audio
       is already being rendered in the <ParticipantStrip /> component.  */
    (<MainParticipantInfo participant={mainParticipant}>
      <ScrollableView width="100%" height="100%">
        <ParticipantTracks
          participant={mainParticipant}
          videoOnly
          videoPriority={videoPriority}
          isLocalParticipant={mainParticipant === localParticipant}
          enableScreenShare={mainParticipant !== localParticipant}
        />
      </ScrollableView>
    </MainParticipantInfo>)
  );
}
